import { createCustomEnum } from "./customEnum";

const UWCheckResultMode = createCustomEnum({
	Valid: {
		value: 1,
		name: "valid",
		displayName: "Valid",
	},
	Empty: {
		value: 2,
		name: "empty",
		displayName: "Empty",
	},
	Error: {
		value: 3,
		name: "error",
		displayName: "Error",
	},
});

export default UWCheckResultMode;
